// extracted by mini-css-extract-plugin
export var icon = "_9l-3";
export var subtitle = "_9l-2";
export var title = "_9l-1";
export var value = "_9l-0";